import { createTheme } from '@mui/material';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#00ca99',
    },
    secondary: {
      main: '#494d4a',
    },
    text: {
      primary: '#333',
    },
    background: {
      default: '#f3f2f0',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 25,
          textTransform: 'none',
        },
      },
    },
  },
});
